import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'routingRuleState' })
export class RoutingRuleStateTablePipe implements PipeTransform {

  transform(state): string {
    const icon = (state === 'UNLOCKED') ? '<i class="fa fa-check true-icon" title="True"></i>'
      : '<i class="fa fa-times false-icon" title="False"></i>';

    return `<div class="center-content">${icon}</div>`;
  }
}
